import { jsx as jsx$1, ThemeContext, Global, css as css$1 } from '@emotion/core';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { space, color, border, size } from 'styled-system';
import React, { cloneElement, forwardRef, useContext, createContext, useState, useRef, Fragment, useEffect, Children } from 'react';
import { useId } from '@reach/auto-id';
import { ThemeProvider } from 'emotion-theming';
import { theme } from '@arc-ui/theme';
import { css } from '@theme-ui/css';
import { render } from 'react-dom';
import { useTransition, animated } from 'react-spring';
import ReachAlert from '@reach/alert';
import { DialogOverlay, DialogContent } from '@reach/dialog';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/** @jsx jsx */
var Box = /*#__PURE__*/
styled('div', {
  shouldForwardProp: shouldForwardProp
})({
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0
}, space, color, border, size);
Box.displayName = 'Box';
var Flex = /*#__PURE__*/
styled(Box)({
  display: 'flex'
});
Flex.displayName = 'Flex';
var icons = {
  ellipsis: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M3.25,8.75c1.795,0,3.25,1.455,3.25,3.25s-1.455,3.25-3.25,3.25S0,13.795,0,12S1.455,8.75,3.25,8.75z M12,8.75 c1.795,0,3.25,1.455,3.25,3.25s-1.455,3.25-3.25,3.25S8.75,13.795,8.75,12S10.205,8.75,12,8.75z M20.75,8.75 C22.545,8.75,24,10.205,24,12s-1.455,3.25-3.25,3.25S17.5,13.795,17.5,12S18.955,8.75,20.75,8.75z",
      fill: "currentColor"
    }),
    title: 'Toggle Overflow Menu'
  },
  warning: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M11.983,0C8.777,0.052,5.72,1.365,3.473,3.653C1.202,5.914-0.052,9.002,0,12.207C-0.008,18.712,5.26,23.992,11.765,24 c0.012,0,0.023,0,0.035,0h0.214c6.678-0.069,12.04-5.531,11.986-12.209l0,0c0.015-6.498-5.24-11.778-11.738-11.794 C12.169-0.003,12.076-0.002,11.983,0z M10.5,16.542c-0.03-0.815,0.606-1.499,1.421-1.529c0.009,0,0.019-0.001,0.028-0.001h0.027 c0.82,0.002,1.492,0.651,1.523,1.47c0.03,0.814-0.605,1.499-1.419,1.529c-0.01,0-0.02,0.001-0.03,0.001h-0.027 C11.203,18.009,10.532,17.361,10.5,16.542z M11,12.5v-6c0-0.552,0.448-1,1-1s1,0.448,1,1v6c0,0.552-0.448,1-1,1S11,13.052,11,12.5z",
      color: "currentColor"
    }),
    title: 'Warning Notification'
  },
  danger: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M11.983,0C8.777,0.052,5.72,1.365,3.473,3.653C1.202,5.914-0.052,9.002,0,12.207C-0.008,18.712,5.26,23.992,11.765,24 c0.012,0,0.023,0,0.035,0h0.214c6.678-0.069,12.04-5.531,11.986-12.209l0,0c0.015-6.498-5.24-11.778-11.738-11.794 C12.169-0.003,12.076-0.002,11.983,0z M10.5,16.542c-0.03-0.815,0.606-1.499,1.421-1.529c0.009,0,0.019-0.001,0.028-0.001h0.027 c0.82,0.002,1.492,0.651,1.523,1.47c0.03,0.814-0.605,1.499-1.419,1.529c-0.01,0-0.02,0.001-0.03,0.001h-0.027 C11.203,18.009,10.532,17.361,10.5,16.542z M11,12.5v-6c0-0.552,0.448-1,1-1s1,0.448,1,1v6c0,0.552-0.448,1-1,1S11,13.052,11,12.5z",
      color: "currentColor"
    }),
    title: 'Error Notification'
  },
  success: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M0 12C0 5.37258 5.37258 0 12 0C18.6242 0.00771476 23.9923 5.37578 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12.082 17.489L18.927 8.2C19.1584 7.91359 19.2137 7.52318 19.0709 7.18377C18.9281 6.84437 18.6104 6.61089 18.2438 6.57604C17.8773 6.54118 17.5212 6.71059 17.317 7.017L11.09 15.468L7.014 12.207C6.58267 11.8618 5.95318 11.9317 5.608 12.363C5.26282 12.7943 5.33267 13.4238 5.764 13.769L10.652 17.677C10.8657 17.844 11.1375 17.9182 11.4064 17.8829C11.6753 17.8475 11.9188 17.7056 12.082 17.489Z",
      fill: "currentColor"
    }),
    title: 'Success Notification'
  },
  publish: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M20.953,4.026c-0.183-0.206-0.499-0.225-0.706-0.042c-0.062,0.055-0.11,0.125-0.138,0.204L19,7.258 C18.73,7.934,18.113,8.41,17.391,8.5h-2.838c-0.274,0.034-0.468,0.284-0.434,0.558c0.007,0.056,0.024,0.111,0.049,0.162l0.885,2.28 c0.084,0.17,0.258,0.277,0.447,0.277h0.829c0.276,0,0.5,0.224,0.499,0.501c0,0.077-0.018,0.153-0.052,0.222L14,18.192 c-0.397,1.047-1.567,1.573-2.614,1.176c-0.628-0.238-1.097-0.772-1.253-1.425l-0.991-4.167C9.057,13.607,8.884,13.5,8.695,13.5 H8.25C6.455,13.5,5,12.045,5,10.25S6.455,7,8.25,7h4.1c0.276,0,0.5-0.224,0.5-0.5V5.354c0-0.815-0.495-1.548-1.25-1.854 l-0.284-0.114c-0.257-0.101-0.383-0.392-0.281-0.649c0.042-0.106,0.119-0.195,0.218-0.251l2.721-1.4 c0.246-0.126,0.343-0.427,0.217-0.673c-0.073-0.142-0.209-0.241-0.367-0.266C13.221,0.05,12.611,0.001,12,0 C5.358-0.014-0.038,5.358-0.052,12s5.358,12.038,12,12.052s12.038-5.358,12.052-12C24.006,9.093,22.921,6.235,20.953,4.026z",
      fill: "currentColor"
    }),
    title: 'Published Notification'
  },
  filter: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M23 0C23.3784 1.26993e-05 23.7245 0.213659 23.894 0.552C24.0638 0.890912 24.0274 1.29672 23.8 1.6L15 13.423V20.5C14.9989 21.1293 14.7028 21.7216 14.2 22.1L12.2 23.6C11.8541 23.8601 11.4328 24.0005 11 24C9.89884 23.9918 9.00817 23.1012 9.00001 22V13.423L0.200006 1.6C-0.0272575 1.29698 -0.0638134 0.89157 0.105579 0.552786C0.274971 0.214002 0.621234 0 1.00001 0H23ZM9.35601 7.45L5.41701 2.2C5.32321 2.07494 5.17633 2.00094 5.02001 2H4.02001C3.83062 2 3.65749 2.107 3.57279 2.27639C3.4881 2.44579 3.50637 2.64849 3.62001 2.8L8.55601 9.3C8.68513 9.47217 8.90995 9.5424 9.11412 9.47434C9.31829 9.40629 9.45601 9.21522 9.45601 9V7.75C9.45601 7.64181 9.42092 7.53655 9.35601 7.45Z"
    }),
    title: 'Toggle Filter Bar'
  },
  filterWebsite: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M24 19.5C24 18.6716 23.3284 18 22.5 18H21.75C21.6119 18 21.5 17.8881 21.5 17.75V12.5C21.5 11.3954 20.6046 10.5 19.5 10.5H13.25C13.1119 10.5 13 10.3881 13 10.25V5.25C13 5.11193 13.1119 5 13.25 5H18.5C19.3284 5 20 4.32843 20 3.5V1.5C20 0.671573 19.3284 0 18.5 0H5.5C4.67157 0 4 0.671573 4 1.5V3.5C4 4.32843 4.67157 5 5.5 5H10.75C10.8881 5 11 5.11193 11 5.25V10.25C11 10.3881 10.8881 10.5 10.75 10.5H4.5C3.39543 10.5 2.5 11.3954 2.5 12.5V17.75C2.5 17.8881 2.38807 18 2.25 18H1.5C0.671573 18 0 18.6716 0 19.5V22.5C0 23.3284 0.671573 24 1.5 24H4.5C5.32843 24 6 23.3284 6 22.5V19.5C6.00017 18.7541 5.45226 18.1214 4.714 18.015C4.59128 17.9971 4.5002 17.892 4.5 17.768V12.749C4.5 12.6109 4.61193 12.499 4.75 12.499H10.75C10.8881 12.499 11 12.6109 11 12.749V17.749C11 17.8871 10.8881 17.999 10.75 17.999H10.5C10.102 17.999 9.72032 18.1572 9.43899 18.4387C9.15765 18.7202 8.99973 19.102 9 19.5V22.5C9 23.3284 9.67157 24 10.5 24H13.5C14.3284 24 15 23.3284 15 22.5V19.5C15 18.6716 14.3284 18 13.5 18H13.25C13.1119 18 13 17.8881 13 17.75V12.75C13 12.6119 13.1119 12.5 13.25 12.5H19.25C19.3881 12.5 19.5 12.6119 19.5 12.75V17.768C19.4998 17.892 19.4087 17.9971 19.286 18.015C18.5477 18.1214 17.9998 18.7541 18 19.5V22.5C18 23.3284 18.6716 24 19.5 24H22.5C23.3284 24 24 23.3284 24 22.5V19.5Z"
    }),
    title: 'Toggle Filter by Website'
  },
  trash: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M19.5,8.99h-15C4.224,8.99,4,9.214,4,9.49v12.5c0,1.105,0.895,2,2,2h12c1.105,0,2-0.895,2-2V9.49 C20,9.214,19.776,8.99,19.5,8.99z M10.25,20.49c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75v-8.625 c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75V20.49z M15.25,20.49c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75 v-8.625c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75V20.49z M20.922,4.851C19.624,4.247,18.228,3.884,16.8,3.78 c-0.649-2.653-3.325-4.278-5.978-3.629C9.03,0.589,7.631,1.988,7.193,3.78C5.807,3.89,4.45,4.237,3.181,4.805 C2.502,5.093,2.045,5.74,2,6.476C1.992,7.028,2.434,7.482,2.986,7.49c0.005,0,0.009,0,0.014,0h18c0.546,0,0.992-0.439,1-0.985 C21.984,5.794,21.566,5.153,20.922,4.851z M11.977,2.01c1.102-0.021,2.12,0.588,2.623,1.569c-1.732-0.101-3.468-0.101-5.2,0 C9.886,2.604,10.888,1.994,11.977,2.01z"
    }),
    title: 'Delete'
  },
  arrowUp: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M23.437,19L13.711,2.93c-0.572-0.945-1.802-1.247-2.747-0.675c-0.276,0.167-0.508,0.399-0.675,0.675L0.563,19 c-0.572,0.945-0.269,2.175,0.676,2.746c0.312,0.189,0.67,0.289,1.035,0.289h19.452c1.105,0,2-0.896,2-2 C23.726,19.67,23.626,19.312,23.437,19z"
    }),
    title: 'Arrow Up'
  },
  checkmark: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M23.146,5.4l-2.792-2.8c-0.195-0.196-0.512-0.196-0.707-0.001c0,0-0.001,0.001-0.001,0.001L7.854,14.4 c-0.195,0.196-0.512,0.196-0.707,0.001c0,0-0.001-0.001-0.001-0.001l-2.792-2.8c-0.195-0.196-0.512-0.196-0.707-0.001 c0,0-0.001,0.001-0.001,0.001l-2.792,2.8c-0.195,0.195-0.195,0.512,0,0.707L7.146,21.4c0.195,0.196,0.512,0.196,0.707,0.001 c0,0,0.001-0.001,0.001-0.001L23.146,6.1C23.337,5.906,23.337,5.594,23.146,5.4z"
    }),
    title: 'Checkmark'
  },
  close: {
    path: /*#__PURE__*/
    React.createElement("path", {
      d: "M14.3,12.179c-0.098-0.098-0.098-0.256,0-0.354c0,0,0,0,0,0l9.263-9.262c0.586-0.587,0.585-1.537-0.002-2.123 s-1.537-0.585-2.122,0.002L12.177,9.7c-0.098,0.098-0.256,0.098-0.354,0c0,0,0,0,0,0L2.561,0.442 C1.975-0.144,1.025-0.144,0.44,0.441s-0.586,1.536-0.001,2.122L9.7,11.825c0.098,0.098,0.098,0.256,0,0.354c0,0,0,0,0,0 l-9.261,9.263c-0.586,0.586-0.585,1.536,0,2.122s1.536,0.585,2.122,0l0,0l9.262-9.263c0.098-0.098,0.256-0.098,0.354,0c0,0,0,0,0,0 l9.262,9.263c0.586,0.586,1.536,0.586,2.122,0s0.586-1.536,0-2.122L14.3,12.179z"
    }),
    title: 'Close'
  }
};
icons.arrowDown = {
  path: /*#__PURE__*/
  cloneElement(icons.arrowUp.path, {
    transform: 'rotate(180 12 12)'
  }),
  title: 'Arrow Down'
};
icons.arrowLeft = {
  path: /*#__PURE__*/
  cloneElement(icons.arrowUp.path, {
    transform: 'rotate(-90 12 12)'
  }),
  title: 'Arrow Left'
};
icons.arrowRight = {
  path: /*#__PURE__*/
  cloneElement(icons.arrowUp.path, {
    transform: 'rotate(90 12 12)'
  }),
  title: 'Arrow Right'
};
var notFound = {
  path: /*#__PURE__*/
  React.createElement("path", {
    d: "M12.05,16.751c1.242-0.002,2.249-1.009,2.25-2.251v-2c0-1.243-1.007-2.25-2.25-2.25S9.8,11.257,9.8,12.5v2 C9.801,15.742,10.808,16.749,12.05,16.751z M11.3,12.5c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v2 c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75l0,0V12.5z M8.8,11.011c-0.001-0.415-0.337-0.75-0.752-0.75 c-0.114,0-0.227,0.026-0.33,0.077c-1.789,0.885-3.049,2.569-3.395,4.535c-0.071,0.408,0.203,0.796,0.611,0.867 c0.042,0.007,0.085,0.011,0.128,0.011H7.05c0.138,0,0.249,0.111,0.25,0.249c0,0.414,0.336,0.75,0.75,0.75 c0.414,0,0.75-0.336,0.75-0.75V11.011z M6.859,12.874c0.089-0.105,0.247-0.119,0.352-0.03C7.268,12.892,7.3,12.962,7.3,13.036V14 c0,0.138-0.112,0.25-0.25,0.25H6.423c-0.139,0-0.251-0.113-0.25-0.252c0-0.037,0.008-0.074,0.024-0.107 C6.374,13.526,6.597,13.184,6.859,12.874z M19.787,11c0-0.259-0.134-0.5-0.354-0.637c-0.22-0.138-0.496-0.152-0.728-0.035 c-1.789,0.885-3.049,2.569-3.395,4.534c-0.07,0.409,0.204,0.797,0.613,0.867c0.042,0.007,0.084,0.011,0.127,0.011h1.987 c0.138,0,0.25,0.112,0.25,0.25c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75L19.787,11z M17.846,12.863 c0.089-0.105,0.247-0.119,0.352-0.03c0.056,0.048,0.089,0.118,0.089,0.192v0.965c0,0.138-0.112,0.25-0.25,0.25H17.41 c-0.138,0.001-0.25-0.11-0.25-0.248c0-0.038,0.008-0.076,0.025-0.11c0.176-0.366,0.398-0.708,0.661-1.018V12.863z M24,4.751 c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v14.5c0,1.657,1.343,3,3,3h18c1.657,0,3-1.343,3-3V4.751z M9.654,3.751 c0.258-0.467,0.845-0.637,1.312-0.38c0.16,0.088,0.292,0.22,0.38,0.38c0.096,0.149,0.149,0.322,0.154,0.5 c-0.005,0.178-0.058,0.351-0.154,0.5c-0.258,0.467-0.845,0.637-1.312,0.38c-0.16-0.088-0.292-0.22-0.38-0.38 C9.558,4.602,9.505,4.429,9.5,4.251C9.505,4.073,9.558,3.9,9.654,3.751z M6.154,3.751c0.258-0.467,0.845-0.637,1.312-0.38 c0.16,0.088,0.292,0.22,0.38,0.38C7.942,3.9,7.995,4.073,8,4.251c-0.005,0.178-0.058,0.351-0.154,0.5 c-0.258,0.467-0.845,0.637-1.312,0.38c-0.16-0.088-0.292-0.22-0.38-0.38C6.058,4.602,6.005,4.429,6,4.251 C6.005,4.073,6.058,3.9,6.154,3.751z M2.592,3.842C2.752,3.484,3.108,3.253,3.5,3.251c0.351,0.004,0.674,0.194,0.846,0.5 C4.442,3.9,4.495,4.073,4.5,4.251c-0.005,0.178-0.058,0.351-0.154,0.5c-0.258,0.467-0.845,0.637-1.312,0.38 c-0.16-0.088-0.292-0.22-0.38-0.38C2.558,4.602,2.505,4.429,2.5,4.251C2.501,4.11,2.532,3.97,2.592,3.842z M22,19.251 c0,0.552-0.448,1-1,1H3c-0.552,0-1-0.448-1-1V7c0-0.138,0.112-0.25,0.25-0.25h19.5C21.888,6.75,22,6.862,22,7V19.251z"
  }),
  title: 'Icon Not Found',
  desc: 'No icon path matched the name provided'
};
var iconPaths = icons;
var Icon = /*#__PURE__*/
forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 2 : _ref$size,
    name = _ref.name,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    title = _ref.title,
    desc = _ref.desc,
    rest = _objectWithoutPropertiesLoose(_ref, ["size", "name", "color", "title", "desc"]);
  var icon = iconPaths[name] || notFound;
  var path = icon.path,
    _icon$title = icon.title,
    iconTitle = _icon$title === void 0 ? '' : _icon$title,
    _icon$desc = icon.desc,
    iconDesc = _icon$desc === void 0 ? '' : _icon$desc;
  var svgTitle = title || iconTitle;
  var svgDesc = desc || iconDesc;
  var titleId = useId();
  var descId = useId();
  return (
    // eslint-disable-next-line
    // @ts-ignore
    jsx$1(Box, Object.assign({
      ref: ref,
      as: "svg",
      size: size,
      color: color,
      role: "presentation",
      viewBox: "0 0 24 24",
      css: {
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0
      },
      "aria-labelledby": "".concat(titleId, " ").concat(descId)
    }, rest), svgTitle && jsx$1("title", {
      id: titleId
    }, svgTitle), svgDesc && jsx$1("desc", {
      id: descId
    }, svgDesc), cloneElement(path, {
      fill: color
    }))
  );
});
Icon.displayName = 'Icon';
var statuses = {
  base: {
    icon: 'warning',
    color: 'gray'
  },
  info: {
    icon: 'publish',
    color: 'blue'
  },
  warning: {
    icon: 'warning',
    color: 'orange'
  },
  success: {
    icon: 'success',
    color: 'blue'
  },
  publish: {
    icon: 'publish',
    color: 'green'
  },
  error: {
    icon: 'danger',
    color: 'red'
  }
};
var AlertContext = /*#__PURE__*/
createContext('base');
var useAlertContext = function useAlertContext() {
  var context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlertContext must be used within a AlertContextProvider');
  }
  return context;
}; // #region DialogInner

var AlertContainerInner = /*#__PURE__*/
forwardRef(function (props, ref) {
  var status = useAlertContext();
  return jsx$1(Box, Object.assign({
    ref: ref,
    role: "alert",
    bg: "".concat(statuses[status].color, ".200"),
    color: "text.".concat(statuses[status].color),
    p: 3,
    borderRadius: 6,
    css: {
      maxWidth: 640,
      minWidth: 540,
      display: 'flex'
    }
  }, props));
});
AlertContainerInner.displayName = 'AlertContainerInner'; // #endregion

var AlertContainer = /*#__PURE__*/
forwardRef(function (_ref, ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'base' : _ref$status,
    props = _objectWithoutPropertiesLoose(_ref, ["status"]);
  return jsx$1(AlertContext.Provider, {
    value: status
  }, jsx$1(AlertContainerInner, Object.assign({
    ref: ref
  }, props)));
});
AlertContainer.displayName = 'AlertContainer';
var AlertAction = /*#__PURE__*/
forwardRef(function (props, ref) {
  var status = useAlertContext();
  var color = statuses[status].color;
  return jsx$1("button", Object.assign({
    ref: ref,
    css: function css(theme) {
      return {
        border: 'none',
        backgroundColor: 'transparent',
        font: '500 1rem OutputSans',
        ':hover': {
          textDecoration: 'underline',
          backgroundColor: theme.colors[color]['300']
        },
        ':active': {
          backgroundColor: theme.colors[color]['400']
        },
        ':focus': {
          outline: "2px solid ".concat(theme.colors[color]['400'])
        },
        width: 'fit-content',
        padding: '4px 16px',
        alignSelf: 'flex-end'
      };
    }
  }, props));
});
AlertAction.displayName = 'AlertAction';
function AlertIcon() {
  var status = useAlertContext();
  return (
    // eslint-disable-next-line
    // @ts-ignore
    jsx$1(Icon, {
      size: 6,
      name: statuses[status].icon,
      css: {
        marginRight: 16
      }
    })
  );
}
function AlertBody(props) {
  return jsx$1(Box, Object.assign({}, props, {
    css: {
      display: 'flex',
      flexDirection: 'column',
      'button:last-of-type': {
        marginTop: 16
      }
    }
  }));
}
var AlertActions = /*#__PURE__*/
forwardRef(function (props, ref) {
  return jsx$1(Box, Object.assign({
    css: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    ref: ref
  }, props));
});
AlertActions.displayName = 'AlertActions'; // Change the name for semantic reasons, but both are essentially flex containers (divs)

var AlertDescription = AlertActions;
AlertDescription.displayName = 'AlertDescription';
/**
 * "An alert is an element that displays a brief, important message in a way that
 * attracts the user's attention without interrupting the user's task."
 * -- [WAI-ARIA Alert](https://www.w3.org/TR/wai-aria-practices-1.1/#alert)
 */

var Alert = /*#__PURE__*/
forwardRef(function (_ref2, ref) {
  var status = _ref2.status,
    children = _ref2.children,
    message = _ref2.message,
    rest = _objectWithoutPropertiesLoose(_ref2, ["status", "children", "message"]);
  return jsx$1(AlertContainer, Object.assign({
    ref: ref,
    status: status
  }, rest), jsx$1(AlertIcon, null), jsx$1(AlertBody, {
    css: {
      width: '100%'
    }
  }, jsx$1(AlertDescription, {
    css: {
      justifyContent: 'flex-start'
    }
  }, message), jsx$1(AlertActions, null, children)));
});
Alert.displayName = 'Alert';

/**
 * Limited variation of an Alert:
 * - Does not allow an Icon
 * - Does not allow error status (see Arc UI docs)
 * - Only one action (children) allowed
 * @see Alert
 */

var Snackbar = /*#__PURE__*/
forwardRef(function (_ref, ref) {
  var message = _ref.message,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, ["message", "children"]);
  return jsx$1(AlertContainer, Object.assign({}, props, {
    ref: ref,
    css: {
      alignItems: 'center',
      justifyContent: 'space-between',
      lineHeight: 1.8,
      'div:first-of-type': {
        marginRight: 8
      }
    }
  }), jsx$1(AlertBody, null, message), children && jsx$1(AlertActions, null, children));
});
Snackbar.displayName = 'Snackbar';

/** @jsx jsx */
var ArcThemeProvider = function ArcThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return jsx(ThemeProvider, {
    theme: theme
  }, jsx(Global, {
    styles: {
      ':root': {
        '--reach-dialog': 1
      }
    }
  }), children);
};
ArcThemeProvider.displayName = 'ArcThemeProvider';
ArcThemeProvider.defaultProps = {
  theme: theme
};
var useArcTheme = function useArcTheme() {
  var themeContext = useContext(ThemeContext);
  if (themeContext === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return themeContext;
};
/**
 * The functions below are stolen from
 * https://github.com/system-ui/theme-ui/blob/master/packages/core/src/index.js
 * to add the sx prop to the project without requiring the rest of theme-ui
 */

var getCSS = function getCSS(props) {
  if (!props.sx && !props.css) return undefined;
  return function (theme) {
    var styles = css(props.sx)(theme);
    var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
    return [styles, raw];
  };
};
var parseProps = function parseProps(props) {
  if (!props) return null;
  var next = {};
  for (var key in props) {
    if (key === 'sx') continue;
    next[key] = props[key];
  }
  var css = getCSS(props);
  if (css) next.css = css;
  return next;
}; // eslint-disable

var jsx = function jsx(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }
  return (
    // eslint-disable-next-line
    jsx$1.apply(undefined, [type, parseProps(props)].concat(children))
  );
};
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    /* Medium */\n    @font-face {\n      font-family: 'OutputSans';\n      src: url('https://resources.arcpublishing.com/font/OutputSans-Medium.woff')\n        format('woff');\n      font-weight: 600;\n      font-style: normal;\n      font-display: swap;\n    }\n\n    /* Medium italic */\n    @font-face {\n      font-family: 'OutputSans';\n      src: url('https://resources.arcpublishing.com/font/OutputSans-MediumItalic.woff')\n        format('woff');\n      font-weight: 600;\n      font-style: italic;\n      font-display: swap;\n    }\n\n    /* Regular */\n    @font-face {\n      font-family: 'OutputSans';\n      src: url('https://resources.arcpublishing.com/font/OutputSans-Regular.woff')\n        format('woff');\n      font-weight: 500;\n      font-style: normal;\n      font-display: swap;\n    }\n\n    html {\n      font-family: 'OutputSans', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n        Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',\n        sans-serif;\n      color: ", ";\n    }\n  "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var Fonts = function Fonts() {
  // eslint-disable-next-line
  var themeCSS = function themeCSS(theme) {
    return css$1(_templateObject(), theme.colors.text["default"]);
  };
  return jsx$1(Global, {
    styles: function styles(theme) {
      return themeCSS(theme);
    }
  });
};

/** @jsx jsx */
/**
 * Hook that calls provided callback when delay has elapsed. Timer
 * starts over if hook is recalled with new delay value.
 *
 * @param callback called when timer is completed
 * @param delay setTimeout duration
 *  Passing null will result in the callback never being called
 */

function useTimeout(callback, delay) {
  var savedCallback = useRef(); // Remember the latest callback.

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.
  // eslint-disable-next-line
  // @ts-ignore

  useEffect(function () {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      var id = setTimeout(tick, delay);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [delay]);
}
/**
 * Animated notification which takes options from
 * the `alertService` and creates an instance of {@link Alert} or
 * {@link Snackbar}. This generated Arc notification components are then
 * wrapped with @reach/alert for a11y benefits.
 *
 * Default values are set by the `AlertManager`, so can use these props
 * as is.
 */

function Notification(_ref) {
  var duration = _ref.duration,
    onRequestRemove = _ref.onRequestRemove,
    status = _ref.status,
    message = _ref.message,
    actions = _ref.actions,
    type = _ref.type;
  var _useState = useState(true),
    localShow = _useState[0],
    setLocalShow = _useState[1];
  var container = useRef(null);
  var _useState2 = useState(duration),
    timeout = _useState2[0],
    setTimeout = _useState2[1];
  var close = function close() {
    return setLocalShow(false);
  };
  var onRest = function onRest() {
    return !localShow && onRequestRemove();
  };
  useTimeout(close, timeout);
  var animation = {
    config: {
      mass: 1,
      tension: 185,
      friction: 26
    },
    from: {
      opacity: 1,
      height: 0,
      transform: "translateY(0) scale(1)"
    },
    enter: function enter() {
      return function (next) {
        var _container$current;
        return next({
          opacity: 1,
          height: (_container$current = container.current) === null || _container$current === void 0 ? void 0 : _container$current.getBoundingClientRect().height,
          transform: "translateY(0) scale(1)"
        });
      };
    },
    leave: {
      opacity: 0,
      height: 0,
      transform: "translateY(0 scale(0.9)"
    },
    onRest: onRest
  };
  var transition = useTransition(localShow, null, animation);
  var makeNotification = function makeNotification() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var NotificationComp = Alert;
    var notification;
    if (status === 'error' && type === 'snack') {
      throw Error('Cannot call error snacks');
    } else if (typeof message === 'string') {
      if (type === 'snack') {
        NotificationComp = Snackbar;
      } // By default make the first action be the dismiss action,
      // for more controlled behavior, use render props

      var withCloseAction = Children.map(actions, function (action, idx) {
        return (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          idx === 0 ? cloneElement(action, {
            onClick: close
          }) : action
        );
      });
      notification = jsx$1(NotificationComp, {
        status: status,
        message: message
      }, withCloseAction);
    } else if (typeof message === 'function') {
      notification = message({
        onClose: close
      });
    } else {
      throw new Error('invalid message');
    }
    /**
     * Not sure if this is the best way here, but `@reach/alert` does not
     * pass down context in order to handle different a11y live regions
     * {@link https://github.com/reach/reach-ui/blob/master/packages/alert/src/index.js}.
     * Defaulting to assuming their reasoning for doing this trumps my own understanding of a11y.
     * So creating another theme provider here so that alerts can render correctly.
     */

    return jsx$1(ArcThemeProvider, null, notification);
  };
  return jsx$1(Fragment, null, transition.map(function (_ref2) {
    var key = _ref2.key,
      item = _ref2.item,
      props = _ref2.props;
    return item && jsx$1(animated.div, {
      key: key,
      onMouseEnter: function onMouseEnter() {
        return setTimeout(null);
      },
      onMouseLeave: function onMouseLeave() {
        return setTimeout(duration);
      },
      style: {
        opacity: props.opacity,
        height: props.height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }
    }, jsx$1(animated.div, {
      ref: container,
      style: {
        transform: props.transform,
        pointerEvents: 'auto'
      }
    }, jsx$1(ReachAlert, null, makeNotification())));
  }));
}
var alertId = 0;
var genId = function genId() {
  return ++alertId;
};
/**
 * Manages state of application notifications (queue and type) and Arc specific
 * notification business logic. Serves as the container for notifications.
 */

function NotificationManager(_ref) {
  var init = _ref.notify;
  var _useState = useState({
      alert: [],
      snack: []
    }),
    alerts = _useState[0],
    setAlerts = _useState[1];
  var removeAlert = function removeAlert(id, type) {
    setAlerts(function (prev) {
      var _extends2;
      return _extends({}, prev, (_extends2 = {}, _extends2[type] = prev[type].filter(function (a) {
        return a.id !== id;
      }), _extends2));
    });
  };
  var notify = function notify(message, options) {
    var _ref2, _ref3;
    var id = genId();
    var type = (_ref2 = options === null || options === void 0 ? void 0 : options.type) !== null && _ref2 !== void 0 ? _ref2 : 'snack'; // ignore duration if type is alert

    var duration = type === 'snack' ? (_ref3 = options === null || options === void 0 ? void 0 : options.duration) !== null && _ref3 !== void 0 ? _ref3 : 3000 : null;
    var alert = {
      id: id,
      message: message,
      type: type,
      status: options.status,
      duration: duration,
      onRequestRemove: function onRequestRemove() {
        return removeAlert(id, type);
      },
      showing: true,
      actions: options.actions
    };
    setAlerts(function (prev) {
      var _extends3;
      return _extends({}, alerts, (_extends3 = {}, _extends3[alert.type] = [].concat(prev[alert.type], [alert]), _extends3));
    });
    return {
      id: alert.id,
      type: alert.type
    };
  };
  /** Basically the same as a class constructor */

  useState(init(notify));
  return jsx$1(Fragment, null, jsx$1("span", {
    css: {
      position: 'fixed',
      pointerEvents: 'none',
      right: 16,
      bottom: 8
    }
  }, alerts.snack.length > 0 && jsx$1(Notification, Object.assign({
    key: alerts.snack[0].id
  }, alerts.snack[0])), alerts.alert.length > 0 && jsx$1("div", {
    css: {
      marginTop: 9
    }
  }, jsx$1(Notification, Object.assign({
    key: alerts.alert[0].id
  }, alerts.alert[0])))));
}
var PORTAL_ID = 'arc-alert';
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var AlertService = function AlertService() {
  var _this = this;

  /**
   * Show notification on the screen
   */
  this.notify = function (message, options) {
    if (_this.createAlert) {
      var defaults = {
        duration: 3000,
        type: 'snack',
        status: 'base'
      };
      _this.createAlert(message, _extends({}, defaults, {}, options));
    }
  };
  if (!isBrowser) {
    return;
  }
  var portalEl;
  var existingPortalEl = document.getElementById(PORTAL_ID);
  if (existingPortalEl) {
    portalEl = existingPortalEl;
  } else {
    var el = document.createElement('arc-alert');
    el.id = PORTAL_ID;
    el.className = 'alert-container';
    document.body.appendChild(el);
    portalEl = el;
  }
  render(React.createElement(NotificationManager, {
    notify: function notify(fn) {
      _this.createAlert = fn;
    }
  }), portalEl);
};
var alertService = /*#__PURE__*/
new AlertService();

/** @jsx jsx */

var makeHeading = function makeHeading(level, props) {
  var tag = "h".concat(level);
  var style = {
    letterSpacing: 0,
    fontSize: tag,
    lineHeight: tag,
    fontWeight: 'medium'
  };
  return jsx(Box, Object.assign({
    as: tag
  }, props, {
    sx: style
  }));
};
function H1(props) {
  return makeHeading(1, props);
}
function H2(props) {
  return makeHeading(2, props);
}
function H3(props) {
  return makeHeading(3, props);
}
var useDialogOverlayStyle = function useDialogOverlayStyle() {
  return {
    background: 'rgba(101, 106, 134, .7)',
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    overflow: 'auto'
  };
};
var SIZES = {
  small: {
    height: '300px',
    width: '450px'
  },
  medium: {
    height: '400px',
    width: '500px'
  },
  large: {
    height: '500px',
    width: '600px'
  }
};
var useDialogContentStyle = function useDialogContentStyle(_ref) {
  var size = _ref.size;
  return _extends({
    bg: 'white',
    outline: 'none',
    margin: '10vh auto',
    padding: 3
  }, SIZES[size]);
};
var dialogSpring = {
  from: {
    opacity: 0,
    transform: 'translateY(8px)'
  },
  enter: {
    opacity: 1,
    transform: 'translateY(0)'
  },
  leave: {
    opacity: 0,
    transform: 'translateY(8px)'
  }
};
var AnimatedOverlay = /*#__PURE__*/
animated(DialogOverlay);
var AnimatedContent = /*#__PURE__*/
animated(DialogContent);
/**
 * Animated wrapper around @reach/dialog
 * @see https://reacttraining.com/reach-ui/dialog
 */

function Dialog(_ref) {
  var children = _ref.children,
    labelledBy = _ref['aria-labelledby'],
    label = _ref['aria-label'],
    isOpen = _ref.isOpen,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    props = _objectWithoutPropertiesLoose(_ref, ["children", "aria-labelledby", "aria-label", "isOpen", "size"]);
  var transitions = useTransition(isOpen, null, dialogSpring);
  var overlayStyle = useDialogOverlayStyle();
  var contentStyle = useDialogContentStyle({
    size: size
  });
  return jsx(Fragment, null, transitions.map(function (_ref2) {
    var item = _ref2.item,
      key = _ref2.key,
      styles = _ref2.props;
    return item && jsx(AnimatedOverlay, Object.assign({
      key: key,
      style: _extends({
        opacity: styles.opacity
      }, overlayStyle)
    }, props), jsx(AnimatedContent, {
      "aria-labelledby": labelledBy,
      "aria-label": label,
      style: {
        transform: styles.transform
      },
      sx: contentStyle
    }, jsx("button", {
      sx: {
        bg: 'transparent',
        border: 'none',
        position: 'absolute',
        top: 3,
        right: 3,
        padding: 0,
        ':focus': {
          outline: 'none',
          boxShadow: 'outline'
        }
      },
      onClick: props.onDismiss
    }, jsx(Icon, {
      name: "close",
      size: 3
    })), jsx(Flex, {
      sx: {
        height: '100%',
        flexDirection: 'column'
      }
    }, children)));
  }));
}
/**
 * Simple component that allows children to be wrapped in a flex container,
 * so that buttons can be aligned correctly. Children should be button components.
 */

function DialogFooter(_ref3) {
  var children = _ref3.children;
  return jsx(Flex, {
    sx: {
      mt: 3,
      '> button': {
        ml: 2
      },
      justifyContent: 'flex-end'
    }
  }, children);
}
function DialogTitle(props) {
  return jsx(H2, Object.assign({
    mb: 3
  }, props));
}
function DialogBody(props) {
  return jsx(Box, Object.assign({
    sx: {
      flex: 1
    }
  }, props));
}
var useButtonStyle = function useButtonStyle(_ref) {
  var color = _ref.color,
    size = _ref.size;
  var baseStyle = {
    display: 'inline',
    appearance: 'none',
    outline: 'none',
    border: 'none',
    borderRadius: 2,
    transition: 'all 200ms',
    userSelect: 'none',
    position: 'relative',
    whiteSpace: 'nowrap',
    fontSize: 'body',
    lineHeight: 'body',
    ':focus': {
      outline: 'none',
      boxShadow: 'outline'
    }
  };
  var sizeStyle = function sizeStyle() {
    return size === 'large' ? {
      py: 1,
      px: 4
    } : {
      py: '0px',
      px: 2
    };
  };
  var variantStyle = function variantStyle() {
    switch (color) {
      case 'primary':
        return {
          bg: 'purple.500',
          color: 'white',
          ':hover': {
            bg: 'purple.800'
          }
        };
      case 'destroy':
        return {
          bg: 'red.500',
          color: 'white',
          ':hover': {
            bg: 'red.800'
          }
        };
      default:
        return {
          bg: 'gray.100',
          color: 'text.default',
          ':hover': {
            bg: 'gray.300'
          }
        };
    }
  };
  return _extends({}, baseStyle, {}, variantStyle(), {}, sizeStyle());
};
var Button = /*#__PURE__*/
forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    props = _objectWithoutPropertiesLoose(_ref, ["variant", "size"]);
  var buttonStyle = useButtonStyle({
    color: variant,
    size: size
  });
  return jsx("button", Object.assign({
    ref: ref
  }, props, {
    sx: buttonStyle
  }));
});
Button.displayName = 'Button';
export { Alert, AlertAction, ArcThemeProvider, Box, Button, Dialog, DialogBody, DialogFooter, DialogTitle, Flex, Fonts, H1, H2, H3, Icon, Snackbar, alertService, dialogSpring, jsx, statuses, useArcTheme };